export const SET_REGION = 'rpb2b-react/locale/SET_REGION';
export type SET_REGION = typeof SET_REGION;

export const SET_LANGUAGE = 'rpb2b-react/locale/SET_LANGUAGE';
export type SET_LANGUAGE = typeof SET_LANGUAGE;

export const SET_CURRENCY = 'rpb2b-react/locale/SET_CURRENCY';
export type SET_CURRENCY = typeof SET_CURRENCY;

export default {
  SET_REGION,
  SET_LANGUAGE,
  SET_CURRENCY
};
